<template>
  <div class="container-fluid">
    <navigation ref="nav" @logout="this.logout" />
    <window-resize />
    <transition name="slide">
      <div v-if="isNavOpened">
        <sidebar
          ref="sidebar"
          :menu-item-id="this.menuItemId"
          :user-site-map.sync="userMenu"
        />
      </div>
    </transition>
    <!-- Page Content -->
    <div v-if="isSearchOpened" class="blured-body" />
    <main
      class="page-content mt-6"
      :class="{ 'mobile-responsive': isMobile, open: isNavOpened }"
    >
      <router-view />
    </main>
  </div>
</template>

<script>
import Navigation from './components/Navigation';
import Sidebar from './components/Sidebar';
import WindowResize from './components/WindowResize';
import store, { name as appModuleName } from '@/modules/app/store/index';
import { mapGetters, mapActions, mapState, mapMutations } from 'vuex';
import { name as userModuleName } from '@/modules/user/store/';
import alert from '@/mixins/alert.mixin';
import hubservice from '@/services/api/hub/hubservice.js';
import Vue from 'vue';

const TICKETS_ROUTE_NAME = 'CaseListMain';
const GUIDE_ROUTE_NAME = '';

export default {
  name: 'MainLayout',
  components: {
    navigation: Navigation,
    sidebar: Sidebar,
    WindowResize,
  },
  mixins: [alert],
  data() {
    return {
      windowWidth: 0,
      sessionExpired: false,
    };
  },
  computed: {
    ...mapGetters(appModuleName, {
      isMobile: 'getIsMobileDensity',
      isNavOpened: 'getIsNavOpen',
    }),
    showRequiredStudentModal() {
      return store.state.showRequiredStudentModal;
    },
    studentSelected() {
      return store.state.selectedStudent;
    },
    isSearchOpened() {
      return store.state.searchOpened;
    },
    ...mapState(userModuleName, ['userMenu', 'menuItemId', 'user']),
  },
  watch: {
    sessionExpired(newValue) {
      if (newValue) {
        this.showCloseAlert();
      }
    },
  },
  async mounted() {
    this.activateActivityTracker();
    if (store.state.isLoggingOut) {
      this.showCloseAlert();
    }
    window.location.hash = '';
  },
  created() {
    Vue.use(hubservice);
    this.$userHub.$on('hub-requisition-update', this.requisitionUpdatedByHub);
  },
  beforeDestroy() {
    window.removeEventListener('mousemove', this.userActivityThrottler);
    window.removeEventListener('scroll', this.userActivityThrottler);
    window.removeEventListener('keydown', this.userActivityThrottler);
    window.removeEventListener('resize', this.userActivityThrottler);

    //clean SignalR event
    this.$userHub.$off('hub-requisition-update', this.requisitionUpdatedByHub);

    /* eslint-disable no-debugger, no-console */
    console.log("hub-requisition-update------------off'");

    clearTimeout(this.userActivityThrottlerTimeout);
  },
  methods: {
    async requisitionUpdatedByHub({ message }) {
      this.ShowToast('Notificación', message, 'warning');
    },
    ...mapActions(userModuleName, ['logout']),
    ...mapMutations(userModuleName, ['toggleNav', 'SET_USER_LOGOUT']),
    onCloseSidebar() {
      if (this.isMobile) {
        this.toggleNav();
      }
    },
    async showCloseAlert() {
      this.ShowAlert(
        'La sesión ha expirado',
        'Debe iniciar sesión nuevamente para continuar.',
        'error',
        async () => {
          this.logout();
        }
      );
    },
    activateActivityTracker() {
      window.addEventListener('mousemove', this.userActivityThrottler);
      window.addEventListener('scroll', this.userActivityThrottler);
      window.addEventListener('keydown', this.userActivityThrottler);
      window.addEventListener('resize', this.userActivityThrottler);
      window.addEventListener('beforeunload', this.deactivateActivityTracker);
    },
    deActivateActivityTracker() {
      window.removeEventListener('mousemove', this.userActivityThrottler);
      window.removeEventListener('scroll', this.userActivityThrottler);
      window.removeEventListener('keydown', this.userActivityThrottler);
      window.removeEventListener('resize', this.userActivityThrottler);
      window.removeEventListener(
        'beforeunload',
        this.deactivateActivityTracker
      );
    },
    userActivityThrottler() {
      if (!this.sessionExpired) {
        clearTimeout(this.userActivityThrottlerTimeout);
        this.userActivityThrottlerTimeout = setTimeout(() => {
          this.handleSessionExpiration();
          clearTimeout(this.userActivityThrottlerTimeout);
        }, process.env.VUE_APP_SESSION_TIMEOUT * 60000);
      }
    },
    async handleSessionExpiration() {
      this.sessionExpired = true;
      this.SET_USER_LOGOUT();
    },
  },
};
</script>

<style scope>
#main {
  margin-bottom: 30px;
}

.page-content {
  padding: 30px;
}

.page-content.open {
  margin-left: 118px;
}

.blured-body {
  left: 119px;
  top: 100px;
  position: fixed;
  height: 100%;
  width: 100%;
  z-index: 11;
}

.blured-body {
  backdrop-filter: blur(8px);
}
</style>
